import React from 'react'

import { cn } from '@/lib/utils'

import { StylesProps } from '../page-header.types'
import { HeaderBanner } from '../shared/header-banner'
import { HeaderDescription } from '../shared/header-description'
import { HeaderLogo } from '../shared/header-logo'
import { HeaderName } from '../shared/header-name'
import { HeaderSocialIcons } from '../shared/header-social-icons'

export const GeexRestaurantPageHeader = ({
  page,
  hasLogoImage,
  forceMobile,
  ...props
}: StylesProps) => {
  return (
    <>
      <div className={cn('p-fluid-4', { 'lg:pt-fluid-14': !forceMobile })}>
        <div className="ft-widget page-header-block ft-widget-wrapper p-fluid-6">
          <div className="flex flex-row items-start justify-between space-x-fluid-4">
            <HeaderName
              name={page?.name}
              {...props}
              className={cn('text-left text-fluid-3xl text-page-heading-text', {
                'text-center mb-fluid-5 w-full': !hasLogoImage,
              })}
            />

            <HeaderLogo
              media={page?.logoMedia}
              {...props}
              className="min-w-fluid-16 rounded-[16px]"
              sizeClassName="size-fluid-16"
              size={64}
            />
          </div>

          <HeaderBanner
            media={page?.bannerMedia}
            {...props}
            className="mb-fluid-4 aspect-square rounded-full"
          />

          <HeaderDescription
            description={page?.description}
            {...props}
            className="text-center text-fluid-base"
          />

          <HeaderSocialIcons
            socialIcons={page?.socialIcons}
            {...props}
            className="mt-fluid-5! justify-center"
            primaryClassName="p-fluid-3 page-header-primary-button min-w-fluid-64"
            type="PRIMARY"
            showPrimaryLabel
          />
        </div>
      </div>

      <div className="p-fluid-4 pt-fluid-0">
        <HeaderSocialIcons
          socialIcons={page?.socialIcons}
          {...props}
          className="page-header-block ft-widget-wrapper justify-center rounded-page-widget p-fluid-2 pb-fluid-0"
          secondaryClassName="p-fluid-3 page-header-secondary-button rounded-page-widget-2!"
          type="SECONDARY"
        />
      </div>
    </>
  )
}
